import axios from 'axios';

export const normalizeApiBaseURL = (value?: string): string | undefined => {
  const baseURL = value?.trim().replace(/\/+$/, '');

  if (!baseURL) return undefined;
  if (/\/dashboard$/i.test(baseURL)) return baseURL;

  return `${baseURL}/dashboard`;
};

const baseURL = normalizeApiBaseURL(process.env.REACT_APP_API_URL);

export const showProductionApiAlert =
  process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENV === 'production';

export const api = axios.create({
  baseURL,
  headers: {},
});

export const applyQueryString = (
  url: string,
  payload: Record<string, any>
): string => {
  const validObject: Record<string, any> = {};

  delete payload.dirty;

  for (const [param, value] of Object.entries(payload)) {
    if (value) Object.assign(validObject, { [param]: value });
  }

  if (Object.keys(validObject).length === 0) {
    return url;
  }

  const searchParams = new URLSearchParams(validObject).toString();

  return `${url}?${searchParams}`;
};

export const queryBuilder = (payload: Record<string, any>): string => {
  const validObject: Record<string, any> = {};
  for (const [param, value] of Object.entries(payload)) {
    if (value) Object.assign(validObject, { [param]: value });
  }

  const searchParams = new URLSearchParams(validObject).toString();
  return searchParams;
};

export const formDataBuilder = (payload: Record<string, any>): FormData => {
  const formData = new FormData();

  for (const [param, value] of Object.entries(payload)) {
    if (value instanceof File) {
      formData.append(param, value, value.name);
    } else if (value instanceof FileList) {
      for (let i = 0; i < value.length; i++) {
        formData.append(`${param}[]`, value[i], value[i].name);
      }
    } else if (value) {
      formData.append(param, value);
    }
  }

  return formData;
};
